import React from "react";

import imageOne from "../../resource/meditate/external-retreat/rules and regulations/1.png";
import imageThree from "../../resource/meditate/external-retreat/rules and regulations/2.png";


const OrganiserInstructions = () => {
  return (
    <div className="externalRules-page inside-pages dark-gold">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>

      <h1 className="mt-4 dark-gold font-main p-4">Organizer Instructions</h1>
      <h1 className="mt-4 dark-gold font-second p-4">for Internal Retreats</h1>
      <div className="p-4 mt-5">
        <p className="h4 mt-5">
        The Bhaddheka Vihari Monastery and Meditation Centre regularly conduct internal retreats led
by our esteemed teachers according to the Theravada Buddhist Tradition.

        </p>

        <h1 className="mt-4 dark-gold font-second">
          Facilities Available for Retreats:
        </h1>

        <p className="h4 mt-5 ">1. Main Dhamma Hall</p>
        <p className="h4 mt-5 ">2. Dana Hall</p>
        <p className="h4 mt-5 ">3. 26 Single Kutis with full amenities</p>
        <p className="h4 mt-5 ">4. Walking meditation paths</p>
        <p className="h4 mt-5 ">5. Spacious open areas</p>
        <p className="h4 mt-5 ">6. Various sanitary facilities</p>

       
        <h1 className="mt-6 dark-gold font-second">
        Responsibilities of the Organizer before a Retreat
        </h1>
        

        <p className="h4 mt-5 ">
        1. Arrive at the monastery at least one week prior to the retreat to inspect all facilities and
ensure they are in good condition. Any defects or damages requiring attention should be
promptly reported to the monastery

        </p>
        <p className="h4 mt-5 ">
        2. Ensure that you have an up-to-date list of all retreatants, including their contact details,
prior to the program.

        </p>
        <p className="h4 mt-5 ">
        3. Maintain continuous communication with the internal retreat administrator and stay
informed of any special needs of the retreatants, such as those requiring accommodations
for disabilities.

        </p>
        <p className="h4 mt-5 ">
        4. Facilitate retreatants with special bedding requirements, including family members or
relatives wishing to share a room, and make necessary arrangements ahead of time.

        </p>
        <p className="h4 mt-5 ">
        5. Inspect the meditation hall for cleanliness, including vacuuming and dusting, and ensure
that all seating arrangements (cushions/chairs) are ready for the retreatants.

        </p>
        <p className="h4 mt-5 ">
        6. Verify that refreshments are fully stocked at the Dana Hall. If there are any shortages,
notify the monastery immediately to ensure supplies are replenished.

        </p>
        <p className="h4 mt-5 ">
        7. Ensure that all keys are available at the monastery office and confirm that all rooms are in
good condition and properly prepared for use.

        </p>
        <p className="h4 mt-5 ">
        8. Ensure that sufficient printed copies of the meditation timetable are available for all
retreatants prior to the start of the retreat.

        </p>

        <p className="h4 mt-5">
        9. Inform retreatants that no dinner will be provided during the retreat period. Retreatants
who require dinner for medical reasons are kindly asked to make private arrangements
for their meals through the retreat organizer. These privately arranged meals should be
consumed in a manner that does not disturb or interfere with the retreat environment or
other retreatants.

        </p>

        <h1 className="mt-6 dark-gold font-second">
        Responsibilities of the Organizer during the Retreat
        </h1>
        <p className="h4 mt-5 ">
        1. The organizer should arrive at the monastery prior to the retreatants arrival in order to
warmly welcome them and ensure all preparations are in place for their arrival.

        </p>
        <p className="h4 mt-5 ">
        2. A log sheet should be maintained using the printed list of retreatants and their contact
details. Ensure that retreatants sign and date the log sheet upon picking up their room
keys.

        </p><p className="h4 mt-5 ">
        3. After registration, provide each retreatant with a printed copy of the meditation timetable
to guide them throughout the retreat.

        </p><p className="h4 mt-5 ">
        4. Discuss with the retreat teacher any important information that needs to be communicated
to the retreatants to ensure clarity and smooth running of the program.

        </p><p className="h4 mt-5 ">
        5. Kindly request that all retreatants gather at the Meditation Hall one hour prior to the start
of the retreat.
        </p><p className="h4 mt-5 ml-5">
         I. Debrief all retreatants on the importance of maintaining noble silence throughout
the retreat program and inform them of the procedures to follow during an
emergency situation.

        </p><p className="h4 mt-5 ml-5">
        II. Inform retreatants that while the monastery does not charge a fee for attending
internal retreats, maintaining the monastery and providing services during the
retreat program incurs significant costs. The monastery kindly encourages
voluntary donations from retreatants to help cover these expenses, should they
wish to contribute.

        </p><p className="h4 mt-5 ">
        6. Provide daily cleaning rosters for the retreatants, which will include the designated times
for cleaning duties: morning: 7:30 – 8:20 am.

        </p><p className="h4 mt-5 ">
        These duties will be assigned on a rotating basis between different teams and will cover
the following areas

        </p><p className="h4 mt-5 ml-5">
        1.	Meditation Hall
        </p>
        <p className="h4 mt-5 ml-5">2.	Daha Hall</p>
        <p className="h4 mt-5 ml-5">3.	Common Areas</p>
        <p className="h4 mt-5 ml-5">4.	Common Toilets</p>
        <p className="h4 mt-5 ml-5">5. Commonly Shared Verandas (Yogi Kuti complex) and surrounding grounds</p>

        <p className="h4 mt-5 ">7. It is the organizer’s responsibility to ensure that noble silence is maintained throughout
the retreat program and that any disturbances are promptly addressed.
</p>
        <p className="h4 mt-5 ">8. Kindly remind retreatants to direct any questions or concerns to the retreat organizer
rather than approaching fellow retreatants. Retreatants should only reach out to others in
case of an emergency.
</p>
        <p className="h4 mt-5 ">9. Ensure that the needs of the retreatants are attended to promptly and with care at all
times.
</p>
        <p className="h4 mt-5 ">10. Inform all retreatants to be mindful of safety precautions in the event of any sudden
changes in weather or extreme heat conditions, particularly during the summer months
</p>

<p className="h4 mt-5 ">11. Kindly remind all retreatants to securely lock their rooms at all times when they are not
present to ensure their personal belongings are safe.
</p>



        <h1 className="mt-6 dark-gold font-second">
        Responsibilities of the Organizer upon Completion of the Retreat
        </h1>
        <p className="h4 mt-5 ">1. Please ensure that retreatants sign and date the log sheet upon returning their room keys.
Use the previously printed list of retreatants to maintain an accurate record of this
activity.
</p>
        <p className="h4 mt-5 ">2. Kindly inform all retreatants that no personal items should remain in the rooms after the
retreat. All personal belongings should be removed before departure.
</p>
        <p className="h4 mt-5 ">3. Ensure that retreatants clean and vacuum their rooms, including wet areas such as
bathrooms, before leaving.
</p>
        <p className="h4 mt-5 ">4. Organizer should inspect all rooms to ensure that no personal items have been left behind
in the yogi&#39;s rooms. Any forgotten items should be reported promptly.
</p>
        <p className="h4 mt-5 ">5. Ensure that the Dhamma Hall is properly cleaned, including the floors and carpets. All
cushions and chairs should be returned to their original positions or moved to the storage
room. Cleaning equipment is available in the storeroom.
</p>
        <p className="h4 mt-5 ">6. Ensure that retreatants clean and properly store all used items such as plates, cups, and
glasses. Any unused water should be disposed of from the kettles. Dry any wet areas
(e.g., sinks and tabletops) and mop any wet floors to maintain cleanliness.
</p>
        <p className="h4 mt-5 ">7. Ensure that retreatants thoroughly clean all common toilets, bathrooms, and kitchenettes,
leaving them in good condition for future use.
</p>
        <p className="h4 mt-5 ">8. Ensure that retreatants clean all common paths, corridors, and veranda (Yogi’s Kuti
complex) areas, maintaining a tidy and welcoming environment.
</p>
        <p className="h4 mt-5 ">9. Make sure that retreatants switch off all lights and air conditioning equipment before
leaving their rooms or any shared spaces.
</p>
        <p className="h4 mt-5 ">10. Inform the Monastery immediately of any damage or worn-out items that require
attention or replacement, ensuring that all facilities are well-maintained
</p>




       </div>

      

      <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image" width={400} />
      </div>
    </div>
  )
}

export default OrganiserInstructions